import * as CacheKeys from 'reference-resolvers/constants/CacheKeys';
//@ts-expect-error untyped
import createSimpleCachedReferenceResolver from 'reference-resolvers/lib/createSimpleCachedReferenceResolver';
import { createGetSmsSubscriptions, getSmsSubscriptions } from '../api/CommunicationSubscriptionAPI';
export const createSmsSubscriptionReferenceResolver = options => createSimpleCachedReferenceResolver(Object.assign({
  cacheKey: CacheKeys.SMS_SUBSCRIPTIONS,
  createFetchData: createGetSmsSubscriptions,
  fetchData: getSmsSubscriptions
}, options));
export default createSmsSubscriptionReferenceResolver();